import { logOut } from "../../redux/auth/authSlice";
import { getLocalizedPathFromLocalStorage } from "./localstorage.helper";
import { getItem } from "./localstorage.helper";
import { toast } from "react-toastify";

export function signOutuser(
    navigate: (path: string) => void,
    user: any,
    dispatch: Function,
    t: (key: string) => string
) {
    if (!user) {
        navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' }));
        return;
    }
    
    // Dispatch logOut action which will be handled by all reducers that have extraReducers for logOut
    dispatch(logOut());
    
    // Clear all localStorage user-related data
    localStorage.removeItem("user");
    localStorage.removeItem("tduid");
    
    // Clear any other sensitive data from localStorage if needed
    const keysToPreserve = ['i18nextLng', 'accept']; // Keep language and cookie preferences
    const keysToRemove = Object.keys(localStorage).filter(key => !keysToPreserve.includes(key) && key.startsWith('app_'));
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    toast.success(t('LOGGED_OUT_SUCCESSFULLY'));
    
    // Navigate to login page
    const loginPath = getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' });
    navigate(loginPath);
}